export const types = {
    SET_ADVANCED_OPERATIONS_VISIBILITY: "set-advanced-operations-visibility",
    SET_VISIBILITY: "top-bar/set-visibility",
    SET_OPTIONS: "top-bar/set-options",
    UPDATE_TIMESTAMP: "top-bar/update-timestamp",
};

/**
 * Sets the visibility of the advanced operations modal.
 *
 * @param visible - Whether the advanced operations modal is visible.
 * @returns The action object.
 */
export const setAdvancedOperationsVisibility = (visible) => ({
    type: types.SET_ADVANCED_OPERATIONS_VISIBILITY,
    payload: visible,
});

/**
 * Sets the visibility of the top bar.
 *
 * @param visible - Whether the top bar is visible.
 * @returns The action object.
 */
export const setVisibility = (visible) => ({
    type: types.SET_VISIBILITY,
    payload: visible,
});

/**
 * Updates the top bar display options.
 *
 * @param options - The top bar display options to update.
 * @returns The action object.
 */
export const setOptions = (options) => ({
    type: types.SET_OPTIONS,
    payload: options,
});

/**
 * Updates the timestamp of the last duplicate check run.
 *
 * @param timestamp - The timestamp of the last duplicate check run.
 * @returns The action object.
 */
export const updateTimeStamp = (timestamp) => ({
    type: types.UPDATE_TIMESTAMP,
    payload: timestamp,
});
